import { zIndexCssDomApplier } from './zIndexCssDomApplier'
import { ZIndexCssFeature } from './zIndexCss.types'
import { defaultZIndexCss } from './zIndexCssCompNode'
import { compLayouts, editorCompLayouts } from '../responsiveLayout/compLayoutsCompNode'
import { pinnedStyle } from '../pinnedLayout/pinnedLayoutCompNode'

export const zIndexCssFeature: ZIndexCssFeature = {
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { defaultZIndexCss },
	intermediateNodes: { compLayouts, pinnedStyle },
	dataMaps: ['document_data', 'layout_data', 'component_properties'],
	domApplier: zIndexCssDomApplier,
}

export const editorZIndexCssFeature: ZIndexCssFeature = {
	...zIndexCssFeature,
	intermediateNodes: { compLayouts: editorCompLayouts, pinnedStyle },
}
